var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reg-auth-forgot__tabs"},[_c('UiTabs',{attrs:{"tabs":_vm.tabsList,"query":false,"value":_vm.activeTab},on:{"input":_vm.changeTab}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }